export const ActionTypes = {
  LOADING: "GET_FINALISTS_LOADING",
  ERROR: "GET_FINALISTS_ERROR",
  SUCCESS: "GET_FINALISTS_SUCCESS",
};
